// typescript
// Instalar dependência (se ainda não tiver):
// npm install libphonenumber-js

// File: src/helpers/validators.ts
import {parsePhoneNumberFromString} from 'libphonenumber-js';

export const validatePhone = (value: string): boolean => {
    if (!value) return false;
    const phone = parsePhoneNumberFromString(value, 'BR');
    return phone ? phone.isValid() : false;
};

export const validateEmail = (value: string): boolean => {
    if (!value) return false;
    // regex simples e eficiente para validação básica
    return /^\S+@\S+\.\S+$/.test(value);
};

export const validateCep = (value: string): boolean => {
    if (!value) return false;
    // aceita 99999-999 ou 99999999
    return /^\d{5}-?\d{3}$/.test(value);
};

// Exemplo de uso (importar em `src/components/Clients/ClientsUsers/ModalClientsUsersInsert/Validate.tsx`):
// import { validatePhone, validateEmail, validateCep } from 'src/helpers/validators';
//
// No seu schema yup você pode continuar usando .test(...) chamando essas funções.
// Observação: para email mais simples use também: yup.string().email().max(150)